import { STATUS_INIT } from 'constants/statuses.constants';

export const getInitialState = () => ({
  constructs: [],
  batches: [],
  status: STATUS_INIT,
  error: null,
});
